import React, { useEffect, useState } from "react";
import { Plus } from "lucide-react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Trash2 } from "lucide-react";
import PartTable from "./PartTable";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import ic_no_data from "../../../../utils/ic_no_data_to_show.svg";
import ic_timeline_circle_indicator from "../../../../utils/ic_timeline_icon.svg";
import { format, set } from "date-fns";
import { Tooltip } from "@mui/material";
import canUserSeeThis from "../../../common/CheckCanUserSeeThis";

const BasicInformation = ({
  itemFromRequest,
  formData,
  setFormData,
  handleSaveEquivalent,
  equivalentEntries,
  setEquivalentEntries,
  fetchImageAllow,
  setFetchImageAllow,
  isEdit,
  saveEquivalentPartTable,
  onEquivalentEntriesChange,
}) => {

  const COMPANY_CODE = localStorage?.getItem("companyCode") || "";

  const [groupList, setGroupList] = useState([]);
  const [subGroupList, setSubGroupList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [unitList, setUnitList] = useState([]);
  const [originList, setOriginList] = useState([]);
  const [imageData, setImageData] = useState(null);
  const [imageViewUrl, setImageViewUrl] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const buildImageUrl = (baseUrl, imagePath) => {
    if (!imagePath) return "";

    return (
      baseUrl?.replace(/\/+$/, "") +
      "/" + // remove trailing slashes
      imagePath
        ?.replace(/\\/g, "/") // convert \ → /
        ?.replace(/^.*BONDTIME_PRODUCT_IMG\//, "BONDTIME_PRODUCT_IMG") // remove disk path
        ?.replace(/^\/+/, "") // remove leading slashes
    );
  };

  const [voucherTimeLineList, setVoucherTimeLineList] = useState([]);

  useEffect(() => {
    fetchMasterList("GROUP", setGroupList);
    fetchMasterList("SUBGROUP", setSubGroupList);
    fetchMasterList("CATEGORY", setCategoryList);
    fetchMasterList("SUBCATEGORY", setSubCategoryList);
    fetchMasterList("UNIT", setUnitList);
    fetchMasterList("ORIGIN", setOriginList);
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    setImageViewUrl(apiPaths[0]?.IMG_API_PATH);
  }, []);
  // console.log("Image View Url", imageViewUrl);

  const getImageUrl = (itemFilePath) => {
    if (!itemFilePath || typeof itemFilePath !== "string") return "";

    const normalizedPath = itemFilePath.replace(/\\/g, "/");

    const splitKey = "BONDTIME_PRODUCT_IMG/";
    const extractedFileName = normalizedPath.includes(splitKey)
      ? normalizedPath.split(splitKey)[1]
      : normalizedPath.split("/").pop();

    if (!extractedFileName) return "";

    // ✅ Only remove trailing slash from base URL
    const cleanBase = imageViewUrl.replace(/\/$/, "");

    return `${cleanBase}/BONDTIME_PRODUCT_IMG/${extractedFileName}`;
  };

  useEffect(() => {
    if (itemFromRequest) {
      // console.log("itemFromRequest in basic information:", itemFromRequest);
      console.log("itemFromRequest in basic information.code:", itemFromRequest.code);
      fetchImage(itemFromRequest.code);
    } else if (formData.code?.length > 0) {
      fetchTransactionLogsData();
      console.log("itemFromRequest in basic information not present:", itemFromRequest);
      fetchImage(formData.code);
    }
  }, [formData.code, itemFromRequest]);

  // useEffect(() => {
  //   if (itemFromRequest) {
  //     console.log("itemFromRequest in basic information:", itemFromRequest);
  //   }
  // }, [itemFromRequest]);

  useEffect(() => {
    // If code becomes empty or invalid → remove image immediately
    if (!formData.code || formData.code.length < 2) {
      setImageData(null);
      return;
    }

    // Only fetch when allowed
    if (fetchImageAllow) {
      const timer = setTimeout(() => {
        fetchImage(formData.code);
        setFetchImageAllow(false);
      }, 400);

      return () => clearTimeout(timer);
    }
  }, [formData.code, fetchImageAllow]);

  const fetchMasterList = async (type, setter) => {
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let companyCode = localStorage.getItem("companyCode") || "-";
    // let url = `${apiPaths[0]?.API_CONFIG}/api/MasterCount/${companyCode}/GROUP/-/-`;
    let url = `${apiPaths[0]?.API_CONFIG}/api/MasterCount/${COMPANY_CODE}/${type}/-/-`;

    try {
      const response = await axios.get(url);
      console.log("responseeee:", response.data);
      setter(response.data || []);
    } catch (err) {
      console.error("Error while loading Voucher Type List:", err);
    }
  };
  let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
  let companyCode = localStorage.getItem("companyCode") || "-";
  let currentUserName = localStorage.getItem("currentUserName");

  const fetchImage = async (code) => {
    // const url = `${apiPaths[0]?.API_CONFIG}/api/CpaysCount/${companyCode}/DOCIMAGE/${formData?.code}/PRODUCTIMAGE`;
    const url = `${apiPaths[0]?.API_CONFIG}/api/CpaysCount/${companyCode}/DOCIMAGE/${code}/PRODUCTIMAGE`;

    try {
      const response = await axios.get(url);
      console.log("FetchImage response.data:", response.data);

      const images = response.data.map((item) => {
        const relativePath = item.Imagepath.split("BONDTIME_PRODUCT_IMG")[1];

        return {
          slno: item.slno,
          imagePath: "\\BONDTIME_PRODUCT_IMG\\" + relativePath,
        };
      });

      setImageData(images);
      setCurrentImageIndex(0);
    } catch (error) {
      console.error("Error fetching image:", error);
      setImageData([]);
    }
  };

  const fetchTransactionLogsData = async () => {
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let department = localStorage.getItem("currentSelectedDepartment") || "-";
    let companyCode = localStorage.getItem("companyCode") || "-";
    let url = `${apiPaths[0]?.API_CONFIG}/api/CRMTaskHistoryList/${companyCode}/PRODUCT/${department}/${formData.code}`;
    try {
      const response = await axios.get(url);

      console.log("response.data transaction logs::", response.data);
      const data = response.data;

      setVoucherTimeLineList(data);
    } catch (error) {
      console.error("Error fetching transaction logs:", error);
    }
  };

  // if (!imageData) return <p>Loading image...</p>;

  useEffect(() => {
    console.log("imageData", imageData?.length);
  }, [imageData]);

  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };
  const updateEntries = (newEntries) => {
    setFormData((prev) => ({ ...prev, entries: newEntries }));
  };
  console.log("FormData:", formData);

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => resolve(reader.result); // KEEP FULL data:image/... prefix
      reader.onerror = (error) => reject(error);

      reader.readAsDataURL(file); // ensures prefix is included
    });
  };
  const updateItemImage = async (companyCode, itemCode) => {
    try {
      const apiPaths = JSON.parse(localStorage.getItem("apiPaths")) || [];
      const BASE_URL = apiPaths[0]?.API_CONFIG;

      const response = await axios.get(
        `${BASE_URL}/api/CRMItemImageUpdate/${companyCode}/${itemCode}`,
      );

      console.log("Item image update success:", response.data);
      return response.data;
    } catch (error) {
      console.error("Item image update failed:", error);
      throw error;
    }
  };

  const uploadImage = async (selectedFile, itemCode) => {
    if (!selectedFile) {
      console.error("No file selected");
      return;
    }

    try {
      const companyCode = localStorage.getItem("companyCode") || "-";

      const apiPaths = JSON.parse(localStorage.getItem("apiPaths")) || [];

      const base64String = await fileToBase64(selectedFile);

      const formData = new FormData();
      formData.append("DOC_CODE", itemCode || "");
      formData.append("DOC_TYPE", "PRODUCTIMAGE");
      formData.append("file", selectedFile);
      formData.append("cmpcode", companyCode);
      formData.append("IMGBASE64", base64String);
      formData.append(
        "IMAGEPATH",
        `${apiPaths[0].IMG_SERVERPATH}\\BONDTIME_PRODUCT_IMG`,
      );
      formData.append("description", "test");

      const response = await axios.post(
        `${apiPaths[0].IMG_POST_PATH}/api/Image/upload`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        },
      );

      console.log("Image Upload Success:", response.data);

      await updateItemImage(companyCode, itemCode);

      showSnackbar("Image uploaded successfully!", "success");
      // fetchImage();

      return response.data;
    } catch (error) {
      console.error("Image Upload Failed:", error);
      showSnackbar("Failed to upload image!", "error");
    }
  };

  const handleAddImage = async () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";

    input.onchange = async (e) => {
      const file = e.target.files[0];

      if (!file) return;

      try {
        const result = await uploadImage(file, formData.code);
        console.log("Result upload image:", result);
      } catch (error) {
        console.error("Upload error:", error);
        showSnackbar("Something went wrong during upload!", "error");
      }
    };

    input.click();
  };
  const handleRemoveItem = async () => {
    if (!imageData?.length) return;

    const currentImage = imageData[currentImageIndex];
    if (!currentImage?.slno) return;

    try {
      const url = `${apiPaths[0]?.API_CONFIG}/api/CRMImageDelete`;

      const payload = [
        {
          CmpCode: companyCode,
          mode: "DELETE",
          docuId: currentImage.slno,
          comments: "Image removed",
          user: currentUserName,
        },
      ];

      await axios.post(url, payload);

      showSnackbar("Image removed successfully", "success");

      // Remove image from UI state
      setImageData((prev) =>
        prev.filter((img) => img.slno !== currentImage.slno),
      );

      // Adjust index safely
      setCurrentImageIndex((prev) => (prev > 0 ? prev - 1 : 0));
    } catch (error) {
      console.error("Failed to delete image:", error);
      showSnackbar("Failed to remove image", "error");
    }
  };

  const handlePrev = () => {
    setCurrentImageIndex((prev) =>
      prev > 0 ? prev - 1 : imageData.length - 1,
    );
  };

  const handleNext = () => {
    setCurrentImageIndex((prev) =>
      prev < imageData.length - 1 ? prev + 1 : 0,
    );
  };

  const showSnackbar = (message, severity = "success") => {
    setSnackbar({ open: true, message, severity });
  };

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  return (
    <div className="p-4 space-y-4">
      <div className="grid grid-cols-4 gap-4">
        {/* Header */}
        <div>
          <h2 className="text-lg font-semibold text-gray-800  pb-2">
            Item Classification
          </h2>
          <div className="">
            {/* Classification Section */}
            <div className="grid grid-cols-1  gap-4">
              <div>
                <label className="block text-xs text-gray-600 mb-1">
                  Vehicle
                </label>
                <select
                  value={formData.group || ""}
                  onChange={(e) => handleChange("group", e.target.value)}
                  className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
                >
                  <option value="">Pick from List</option>
                  {groupList?.map((group, index) => (
                    <option key={index} value={group["GRP CODE"]}>
                      {group.DESCRIPTION}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-xs text-gray-600 mb-1">
                  {/* Sub Group */}
                  Brand
                </label>
                <select
                  value={formData.subGroup || ""}
                  onChange={(e) => handleChange("subGroup", e.target.value)}
                  className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
                >
                  <option value="">Pick from List</option>
                  {subGroupList?.map((group, index) => (
                    <option key={index} value={group["GRP CODE"]}>
                      {group.DESCRIPTION}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-xs text-gray-600 mb-1">
                  Category
                </label>
                <select
                  value={formData.category || ""}
                  onChange={(e) => handleChange("category", e.target.value)}
                  className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
                >
                  <option value="">Pick from List</option>
                  {categoryList?.map((group, index) => (
                    <option key={index} value={group["GRP CODE"]}>
                      {group.DESCRIPTION}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-xs text-gray-600 mb-1">
                  Sub Category
                </label>
                <select
                  value={formData.subCategory || ""}
                  onChange={(e) => handleChange("subCategory", e.target.value)}
                  className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
                >
                  <option value="">Pick from List</option>
                  {subCategoryList?.map((group, index) => (
                    <option key={index} value={group["GRP CODE"]}>
                      {group.DESCRIPTION}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-xs text-gray-600 mb-1">
                  Class
                </label>
                <input
                  value={formData.classType || ""}
                  onChange={(e) => handleChange("classType", e.target.value)}
                  className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
                  placeholder=" Class"
                />
              </div>
              {/* <div>
                <label className="block text-xs text-gray-600 mb-1">
                  Class
                </label>
                <select
                  value={formData.classType || ""}
                  onChange={(e) => handleChange("classType", e.target.value)}
                  className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
                >
                  <option value="">Pick from List</option>
                  <option>OEM</option>
                  <option>Aftermarket</option>
                </select>
              </div> */}
            </div>
          </div>
        </div>
        <div>
          {/* Inventory & Costing Details */}
          <h2 className="text-lg font-semibold text-gray-800  pb-2 ">
            Inventory & Costing Details
          </h2>
          <div className="grid grid-cols-1 gap-4">
            <div>
              <label className="block text-xs text-gray-600 mb-1">
                Opening Qty
              </label>
              <input
                type="number"
                value={formData.openingQty || ""}
                onChange={(e) => handleChange("openingQty", e.target.value)}
                className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
                placeholder="Opening Qty"
              />
            </div>
            {(() => {
              const ua = JSON.parse(localStorage.getItem("currentUser") || "[]")?.[0]?.useraccess || "";
              return !["-AC", "-SW", "-ST"].some(code => ua.includes(code));
            })() && (
                <div>
                  <label className="block text-xs text-gray-600 mb-1">
                    Opening Cost
                  </label>
                  <input
                    type="number"
                    value={formData.openingCost || ""}
                    onChange={(e) => handleChange("openingCost", e.target.value)}
                    className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
                    placeholder="Opening Cost"
                  />
                </div>
              )}

            <div>
              <label className="block text-xs text-gray-600 mb-1">
                Base Unit
              </label>
              <select
                value={formData.baseUnit || ""}
                onChange={(e) => handleChange("baseUnit", e.target.value)}
                className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
              >
                <option value="">Pick from List</option>
                {unitList?.map((group, index) => (
                  <option key={index} value={group.UNIT}>
                    {group.UNIT}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-xs text-gray-600 mb-1">
                Base Bin
              </label>
              <input
                type="text"
                value={formData.baseBin || ""}
                onChange={(e) => handleChange("baseBin", e.target.value)}
                className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
                placeholder="Base Bin"
              />
            </div>
          </div>
        </div>
        <div className="mt-9">
          <div className="grid grid-cols-1 gap-4">
            <div>
              <label className="block text-xs text-gray-600 mb-1">
                Minimum Qty
              </label>
              <input
                type="number"
                value={formData.minQty || ""}
                onChange={(e) => handleChange("minQty", e.target.value)}
                className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
                placeholder="Minimum Qty"
              />
            </div>
            <div>
              <label className="block text-xs text-gray-600 mb-1">
                Balance Qty
              </label>
              <input
                value={formData.balanceQty || ""}
                // onChange={(e) => handleChange("costAvg", e.target.value)}
                readOnly
                className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border-none"
              // placeholder="LP Cost"
              />
            </div>

            {(() => {
              const ua = JSON.parse(localStorage.getItem("currentUser") || "[]")?.[0]?.useraccess || "";
              return !["-AC", "-SW", "-ST"].some(code => ua.includes(code));
            })() && (
                <div>
                  <label className="block text-xs text-gray-600 mb-1">
                    Cost Avg
                  </label>
                  <input
                    value={formData.costAvg || ""}
                    readOnly
                    className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border-none"
                  />
                </div>
              )}
            <div>
              <label className="block text-xs text-gray-600 mb-1">
                LP Cost
              </label>
              <input
                value={formData.lpCost || ""}
                onChange={(e) => handleChange("lpCost", e.target.value)}
                // readOnly
                className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border-none"
              // placeholder="LP Cost"
              />
              {/* <select
                value={formData.lpCost || ""}
                onChange={(e) => handleChange("lpCost", e.target.value)}
                className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
              >
                <option value="">Pick from List</option>
                <option>Piece</option>
                <option>Box</option>
              </select> */}
            </div>
          </div>
        </div>
        <div>
          {imageData && imageData.length > 0 ? (
            <div className="max-w-sm p-4 rounded shadow md:p-6">
              <div className="flex items-center justify-center h-48 mb-4 rounded overflow-hidden">
                <img
                  src={getImageUrl(imageData[currentImageIndex]?.imagePath)}
                  alt={`Product ${currentImageIndex + 1}`}
                  className="object-contain h-full"
                  key={currentImageIndex}
                  onError={(e) => {
                    console.error("Image load error");
                    console.log(
                      "Failed URL:",
                      getImageUrl(imageData[currentImageIndex]),
                    );
                  }}
                />
              </div>
              {/* Show image counter */}
              <div className="text-center text-sm text-gray-600 mb-2">
                Image {currentImageIndex + 1} of {imageData.length}
              </div>
            </div>
          ) : (
            <div className="max-w-sm p-4 rounded shadow animate-pulse md:p-6">
              <div className="flex items-center justify-center h-48 mb-4 bg-gray-200 rounded dark:bg-gray-300">
                <svg
                  className="w-10 h-10 text-gray-200 dark:text-gray-400"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 16 20"
                >
                  <path d="M14.066 0H7v5a2 2 0 0 1-2 2H0v11a1.97 1.97 0 0 0 1.934 2h12.132A1.97 1.97 0 0 0 16 18V2a1.97 1.97 0 0 0-1.934-2ZM10.5 6a1.5 1.5 0 1 1 0 2.999A1.5 1.5 0 0 1 10.5 6Zm2.221 10.515a1 1 0 0 1-.858.485h-8a1 1 0 0 1-.9-1.43L5.6 10.039a.978.978 0 0 1 .936-.57 1 1 0 0 1 .9.632l1.181 2.981.541-1a.945.945 0 0 1 .883-.522 1 1 0 0 1 .879.529l1.832 3.438a1 1 0 0 1-.031.988Z"></path>
                  <path d="M5 5V.13a2.96 2.96 0 0 0-1.293.749L.879 3.707A2.98 2.98 0 0 0 .13 5H5Z"></path>
                </svg>
              </div>
              <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-300 w-48 mb-4"></div>
              <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-300 mb-2.5"></div>
              <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-300 mb-2.5"></div>
              <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-300"></div>
              <span className="sr-only">Loading...</span>
            </div>
          )}

          <div className="flex justify-between items-center mt-4">
            {imageData?.length > 1 && (
              <button
                type="button"
                onClick={handlePrev}
                className="p-2 bg-gray-200 hover:bg-gray-300 rounded-md shadow"
              >
                <ChevronLeft className="w-4 h-4 text-gray-700" />
              </button>
            )}

            <Tooltip
              title={formData.code === "" ? "Please enter code" : ""}
              arrow
            >
              {canUserSeeThis("AE") && (
                <span>
                  <button
                    onClick={handleAddImage}
                    disabled={!formData.code}
                    className={`px-4 py-2  text-white rounded  transition flex justify-center items-center gap-2   
                ${!formData.code
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-green-500 hover:bg-green-700"
                      }`}
                  >
                    <Plus className="w-3 h-4" />
                    <span className="text-sm">Add</span>
                  </button>

                </span>
              )}
            </Tooltip>
            <Tooltip
              title={formData.code === "" ? "Please enter code" : ""}
              arrow
            >
              {canUserSeeThis("AE") && (
                <span>
                  <button
                    onClick={handleRemoveItem}
                    className={`px-4 py-2 text-white rounded  transition flex justify-center items-center gap-2
                  ${!formData.code
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-red-500 hover:bg-red-700"
                      }
                  `}
                  >
                    <Trash2 className="w-3 h-4" />
                    <span className=" text-sm">Remove</span>
                  </button>
                </span>
              )}
            </Tooltip>

            {imageData?.length > 1 && (
              <button
                type="button"
                onClick={handleNext}
                className="p-2 bg-gray-200 hover:bg-gray-300 rounded-md shadow"
              >
                <ChevronRight className="w-4 h-4 text-gray-700" />
              </button>
            )}
          </div>

          <p className="mt-2 text-xs text-gray-400 text-center">
            Only <span className="font-medium">JPG</span> and{" "}
            <span className="font-medium">PNG</span> formats are allowed!
          </p>
        </div>
      </div>

      <div className="grid grid-cols-4 gap-4">
        <div>
          {/* Logistics Information */}
          <h2 className="text-lg font-semibold text-gray-800 pb-2 mt-4">
            Logistics Information
          </h2>
          <div className="grid grid-cols-1 gap-4">
            <div className="flex items-center justify-between">
              <div>
                <label className="block text-xs text-gray-600 mb-1">
                  Volume
                </label>
                <input
                  type="number"
                  value={formData.volume || ""}
                  onChange={(e) => handleChange("volume", e.target.value)}
                  className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
                  placeholder="Volume"
                />
              </div>
              <div>
                <label className="block text-xs text-gray-600 mb-1">
                  Weight (Kg)
                </label>
                <input
                  type="number"
                  value={formData.weight || ""}
                  onChange={(e) => handleChange("weight", e.target.value)}
                  className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
                  placeholder="Weight"
                />
              </div>
            </div>
            <div>
              <label className="block text-xs text-gray-600 mb-1">
                HS Code
              </label>
              <input
                type="text"
                value={formData.hsCode || ""}
                onChange={(e) => handleChange("hsCode", e.target.value)}
                className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
                placeholder="HS Code (Auto fill)"
              />
            </div>

            <div>
              <label className="block text-xs text-gray-600 mb-1">Origin</label>
              <select
                value={formData.origin || ""}
                onChange={(e) => handleChange("origin", e.target.value)}
                className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
              >
                <option value="">Pick from List</option>
                {originList?.map((orig, index) => (
                  <option key={index} value={orig.CODE}>
                    {orig.NAME}
                  </option>
                ))}
              </select>
            </div>

            <div className="mt-2">
              <div className="flex justify-between items-center">
                <label className="block text-xs text-gray-600 mb-1">
                  Flash Comment Type <span className="text-red-600">*</span>
                </label>
              </div>
              <textarea
                value={formData.flashCommentType || ""}
                onChange={(e) =>
                  handleChange("flashCommentType", e.target.value)
                }
                placeholder="Flash Comment Type"
                className="p-2 rounded-lg bg-gray-100 border border-gray-200 focus:ring-blue-500 focus:border-blue-500 w-full h-[85px] placeholder:text-gray-400"
                rows={4}
              />
            </div>
          </div>
        </div>
        <div>
          {/* Logistics Information */}
          <h2 className="text-lg font-semibold text-gray-800 pb-2 mt-4">
            Pricing & Sales Details
          </h2>
          <div className="grid grid-cols-1 gap-4">
            <div>
              <label className="block text-xs text-gray-600 mb-1">
                Retail Price
              </label>
              <input
                value={formData.retailPrice || ""}
                onChange={(e) => handleChange("retailPrice", e.target.value)}
                className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
                placeholder="Retail Price"
              />
            </div>

            <div>
              <label className="block text-xs text-gray-600 mb-1">
                Reseller Price
              </label>
              <input
                value={formData.resellerPrice || ""}
                onChange={(e) => handleChange("resellerPrice", e.target.value)}
                className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
                placeholder="Reseller Price"
              />
            </div>

            <div>
              <label className="block text-xs text-gray-600 mb-1">
                Export Price
              </label>
              <input
                value={formData.exportPrice || ""}
                onChange={(e) => handleChange("exportPrice", e.target.value)}
                className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
                placeholder="Export Price"
              />
            </div>

            <div>
              <label className="block text-xs text-gray-600 mb-1">
                Block Price
              </label>
              <input
                value={formData.blockPrice || ""}
                onChange={(e) => handleChange("blockPrice", e.target.value)}
                className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
                placeholder="Block Price"
              />
            </div>

            <div>
              <label className="block text-xs text-gray-600 mb-1">DCP</label>
              <input
                value={formData.dcp || ""}
                onChange={(e) => handleChange("dcp", e.target.value)}
                className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
                placeholder="DCP"
              />
            </div>
          </div>
        </div>
        <div className="mt-4">
          <h2 className="text-lg font-semibold text-gray-800 ">
            Genuine Equivalents
          </h2>
          {/* <PartTable
            entries={formData.entries ?? []}
            onEntriesChange={updateEntries}
          /> */}
          {/* <PartTable mode="GENEQUI" mainCode={formData.code} /> */}

          <PartTable
            entries={equivalentEntries}
            setEntries={setEquivalentEntries}
            mainCode={formData.code}
            mode="GENEQUI"
            title="OEM Brand"
            onSave={handleSaveEquivalent}
            savePartTable={saveEquivalentPartTable}
            onEntriesChange={onEquivalentEntriesChange}
            isEdit={isEdit}
          />
        </div>
        <div className="mt-4">
          <h2 className="text-lg font-semibold text-gray-800 ">Alternates</h2>
          <PartTable
            mainCode={formData.code}
            mode="ALTERNATE"
            title="Alternate"
            onEntriesChange={onEquivalentEntriesChange}
            isEdit={isEdit}
          />
        </div>
      </div>
      <div>
        {/* <label className="block text-sm font-medium mb-1">
                
              </label> */}
        <h2 className="text-lg font-semibold text-gray-800 ">
          Transaction Logs
        </h2>
        <div
          className="bg-[#F3F4F6]  rounded border"
          style={{
            height: "160px",
            overflowY: "scroll",
            padding: "6px",
            // marginRight: "10px",
          }}
        >
          {voucherTimeLineList ? (
            voucherTimeLineList.length > 0 ? (
              voucherTimeLineList?.map((item) => {
                return (
                  <div className=" bg-white border rounded shadow p-1 m-2">
                    <p className="flex">
                      <div>
                        <img src={ic_timeline_circle_indicator} />
                      </div>
                      <div className="ms-2  w-full">
                        <div className="flex justify-between items-center">
                          <div>
                            <span className="text-xs font-semibold">
                              {format(item.create_date, "dd-MM-yyyy")}{" "}
                            </span>
                            <span
                              className="text-xs font-semibold"
                              style={{ marginLeft: "5px" }}
                            >
                              {format(item.create_date, "hh:mm a")}{" "}
                            </span>
                            <span
                              className="text-xs font-semibold"
                              style={{ marginLeft: "5px" }}
                            >
                              User: {item.userid}
                            </span>
                          </div>
                          <div className="px-1">
                            <span className="bg-gray-100 text-gray-400 text-xs font-medium me-2 px-1.5 py-0.5 rounded dark:bg-gray-700 dark:text-white">
                              {" "}
                              {item.status}{" "}
                            </span>
                          </div>
                        </div>
                        <div>
                          <span>{item.Comments}</span>
                        </div>
                      </div>
                    </p>
                  </div>
                );
              })
            ) : (
              <div style={{ display: "flex", alignItems: "center" }}>
                <img style={{ width: "90px" }} src={ic_no_data} />
                <p className="p-2 text-slate-500">
                  {" "}
                  No data in Transaction logs
                </p>
              </div>
            )
          ) : (
            <p>Unable to fetch Transaction Logs.</p>
          )}
        </div>
      </div>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default BasicInformation;
